import { Injectable, Inject, InjectionToken } from '@angular/core';

export const ESTENSA_MODULE_MODAL_SPINNER_SERVICE = new InjectionToken('estensa.module.modalspinner.service');

@Injectable({
    providedIn: 'root',
})
export class ModalSpinnerService {

    // data members
    
    // constructor

    constructor( @Inject(ESTENSA_MODULE_MODAL_SPINNER_SERVICE) private modalSpinnerService) {
    }

    // public functions

    setBusy(isBusy) {
        
        if (isBusy)
            this.modalSpinnerService.displayLoading('#ebitBodyApp');
        else
            this.modalSpinnerService.removeDisplayLoading('#ebitBodyApp');
    }
}
